export default {
  账号: '账号',
  密码: '密码',
  重置: '重置',
  登录: '登录',
  请输入密码: '请输入密码',
  '密码长度在 3 到 5 个字符': '密码长度在 3 到 5 个字符',
  请输入账号: '请输入账号',
  '去选择仓库！': '去选择仓库！',
  返回登录: '返回登录',
  进入仓库: '进入仓库',
  无权限: '无权限',
  中文: "中文",
  日文: "日文",
  "去选择仓库！": "去选择仓库！",
  未登录: '未登录',
  "登录失效，重新登入！": "登录失效，重新登入！"
}